import React, { Component } from 'react';

class Image extends Component {


  render() {
    let src = this.props.reactsrc;
    let { type } = this.props;

    const {
      ...props
    } = this.props;

    try {
      if (type === "external")
        src = 'https://pagtel.com.br' + src;
      else if (type === "internal") {
        src = require('../../images/' + src.replace(",",""));
      }

    } catch (error) {
      console.log(error);
    }

    return (
      <img
        src={src}
        {...props}
      />
    );
  }
}

export default Image;
